import { LocationsEntity } from './../redux/stores/location.store';
import { Injectable, OnDestroy } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AuthTrackingService, ProxyService, LocationCoreService } from '@core/services';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';

import { OrderStatusTypes } from '@shared/models/order-status-types.model';

import { Observable ,  Subscription } from 'rxjs';

@Injectable()
export class StartOrderGuard implements CanActivate, OnDestroy {

  private subscriptions = new Subscription();

  constructor(
    private router: Router,
    private authService: AuthTrackingService,
    private proxy: ProxyService,
    private locationCoreService: LocationCoreService,
  ) {
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean>|boolean {

    return new Observable<boolean>(
      (observer) => {
        // This logic works for new guard for start new order.
        // The fucntionality requirements dictate that if a user is signed in and
        // they have a favorite order(s), previous order(s), or active order in redux
        // then go to the start new order screen. Otherwise go to the select a location screen
        // all guest user will be directed to the location screen regardless.
        const isLoggedIn = this.authService.isLoggedIn();
        if (isLoggedIn) {
          this.proxy.httpGet(ApiRoutes.GET_FAVORITES).toPromise().then(
            (success) => {
              const userFavorites = <Array<any>>success.body.valueOf();
              // check if there are favorites if so, then go to start new order, else check pending orders
              if (userFavorites === undefined || (userFavorites !== undefined && userFavorites.length <= 0)) {

                this.proxy.httpGet(ApiRoutes.GET_RECENT_ORDERS + '/1' + '?status=' + OrderStatusTypes.PENDING).toPromise().then(
                  (pendingOrdersSuccess) => {
                    const pendingUserOrders = <Array<any>>pendingOrdersSuccess.body.valueOf();
                    // check if there are pending orders if so, then go to start new order, else check for historical orders
                    if (pendingUserOrders === undefined || (pendingUserOrders !== undefined && pendingUserOrders.length <= 0)) {
                      this.proxy.httpGet(ApiRoutes.GET_RECENT_ORDERS + '/1' + '?status=' + OrderStatusTypes.PAST).toPromise().then(
                        (orderSuccess) => {
                          const userOrders = <Array<any>>orderSuccess.body.valueOf();
                          // if no favorites, orders, or pending orders found then go to location
                          if (userOrders === undefined || (userOrders !== undefined && userOrders.length <= 0)) {
                            this.handleStartOrderLocation(observer, route);
                          } else {
                            observer.next(true);
                            observer.complete();
                          }
                        },
                        (error) => {
                          this.handleStartOrderLocation(observer, route);
                        }
                      );
                    } else {
                      observer.next(true);
                      observer.complete();
                    }
                  },
                  (error) => {
                    this.handleStartOrderLocation(observer, route);
                  }
                );
              } else {
                observer.next(true);
                observer.complete();
              }
            },
            (error) => {
              this.handleStartOrderLocation(observer, route);
            }
          );
        } else {
          this.handleStartOrderLocation(observer,route, true);
        }
      }
    );
  }

  private handleStartOrderLocation(observer,route: ActivatedRouteSnapshot, isGuest = false) {
    this.locationCoreService.getAssumedLocation(isGuest).then((success: LocationsEntity) => {
      if (success && success.unit) {
        this.router.navigate([`/locations/${success.unit}/menu`], {queryParams: route.queryParams });
      } else {
        this.router.navigate(['/locations'], {queryParams: route.queryParams });
      }
      observer.next(false);
      observer.complete();
    }, (error) => {
      this.router.navigate(['/locations'], {queryParams: route.queryParams });
      observer.next(false);
      observer.complete();
    });
  }
}
